var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-form",
    {
      ref: "ruleForm",
      attrs: {
        model: _vm.currentComponent,
        "label-width": "100px",
        isNeedRequire: "",
        isNeedTooltip: "",
        "label-position": "top",
      },
    },
    [
      _c(
        "yxt-form-item",
        {
          attrs: {
            label: _vm.$t("pc_biz_ote_lbl_questionstem"),
            rules: _vm.rulesContent,
            prop: "content",
            size: "small",
          },
        },
        [
          _c("common-attachment-textfield", {
            attrs: {
              content: _vm.currentComponent.content,
              "single-limit": "",
            },
            on: {
              "update:content": function ($event) {
                return _vm.$set(_vm.currentComponent, "content", $event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "yxt-form-item",
        {
          staticClass: "mb24",
          attrs: { label: _vm.$t("pc_biz_ote_lbl_itemanswer"), size: "small" },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "yxtbiz-ote-edit-ques-kw yxtbiz-ote-edit-ques-kw--fillin",
            },
            [
              _vm._l(
                _vm.currentComponent.itemAnswerObj,
                function (item, index2) {
                  return _c("div", { key: item.id, staticClass: "mb8" }, [
                    _c("div", { staticClass: "lh22 mb8" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("pc_biz_ote_lbl_itemanswer")) +
                          "\n          "
                      ),
                      _c("span", { staticClass: "min-w-16 d-in-block" }, [
                        _vm._v(_vm._s(index2 + 1)),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "flex flex-wrap" },
                      [
                        _vm._l(Object.keys(item), function (answer, i) {
                          return _c(
                            "yxt-form-item",
                            {
                              key: "a" + i + Object.keys(item).length,
                              attrs: {
                                rules: _vm.rulesItem(item[answer]),
                                prop: "itemAnswerObj." + index2 + "." + answer,
                                size: "small",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "flex" },
                                [
                                  _c("yxt-input", {
                                    ref: "editorItem_input" + index2,
                                    refInFor: true,
                                    staticClass: "width120",
                                    attrs: { maxlength: "200" },
                                    on: {
                                      input: function ($event) {
                                        return _vm.changeValue(
                                          _vm.currentComponent.itemAnswerObj,
                                          index2,
                                          answer,
                                          $event
                                        )
                                      },
                                    },
                                    model: {
                                      value: item[answer],
                                      callback: function ($$v) {
                                        _vm.$set(item, answer, $$v)
                                      },
                                      expression: "item[answer]",
                                    },
                                  }),
                                  _c(
                                    "div",
                                    { staticClass: "flex flex-mid" },
                                    [
                                      Object.keys(item).length > 1
                                        ? _c(
                                            "yxt-tooltip",
                                            {
                                              attrs: {
                                                content: _vm.$t(
                                                  "pc_biz_ote_btn_delete"
                                                ),
                                                placement: "top",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "yxtbiz-ote-ai-icon hand mh2 color-gray-8",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.delItemAnswer(
                                                        _vm.index,
                                                        i,
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("yxt-svg", {
                                                    attrs: {
                                                      width: "16px",
                                                      height: "16px",
                                                      "icon-class":
                                                        "minus-circle-o",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      i === Object.keys(item).length - 1 &&
                                      Object.keys(item).length < 6
                                        ? _c(
                                            "yxt-tooltip",
                                            {
                                              attrs: {
                                                content: _vm.$t(
                                                  "pc_biz_ote_tip_alternativeanswertip"
                                                ),
                                                placement: "top",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "yxtbiz-ote-ai-icon hand mh2 color-gray-8",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.addItemAnswer(
                                                        _vm.index,
                                                        i,
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("yxt-svg", {
                                                    attrs: {
                                                      width: "16px",
                                                      height: "16px",
                                                      "icon-class":
                                                        "plus-circle-o",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          )
                        }),
                        _c(
                          "div",
                          { staticClass: "flex flex-mid height32" },
                          [
                            _c(
                              "yxt-tooltip",
                              {
                                attrs: {
                                  content: _vm.$t("pc_biz_ote_btn_delete"),
                                  placement: "top",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "yxtbiz-ote-ai-icon hand mh2 color-gray-8",
                                    on: {
                                      click: function ($event) {
                                        return _vm.delItem(index2)
                                      },
                                    },
                                  },
                                  [
                                    _c("yxt-svg", {
                                      attrs: {
                                        width: "16px",
                                        height: "16px",
                                        "icon-class": "delete",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
                  ])
                }
              ),
              _c(
                "div",
                { staticClass: "mt8 lh22" },
                [
                  _c(
                    "yxt-button",
                    {
                      attrs: {
                        type: "text",
                        disabled:
                          _vm.currentComponent.itemAnswerObj &&
                          _vm.currentComponent.itemAnswerObj.length >= 12,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.addItem()
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex flex-mid" },
                        [
                          _c("yxt-svg", {
                            staticClass: "mr4",
                            attrs: {
                              width: "16px",
                              height: "16px",
                              "icon-class": "common_plus",
                            },
                          }),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("pc_biz_ote_btn_newanswer"))),
                          ]),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "yxt-checkbox",
                {
                  staticClass: "mt16",
                  attrs: { "true-label": 1, "false-label": 0 },
                  model: {
                    value: _vm.currentComponent.noOrderMark,
                    callback: function ($$v) {
                      _vm.$set(_vm.currentComponent, "noOrderMark", $$v)
                    },
                    expression: "currentComponent.noOrderMark",
                  },
                },
                [_vm._v(_vm._s(_vm.$t("pc_biz_ote_lbl_answersmultipleorder")))]
              ),
            ],
            2
          ),
        ]
      ),
      _c(
        "yxt-form-item",
        {
          attrs: { label: _vm.$t("pc_biz_ote_lbl_quesanalyze"), size: "small" },
        },
        [
          _c("common-attachment-textfield", {
            attrs: {
              content: _vm.currentComponent.explainText,
              "single-limit": "",
            },
            on: {
              "update:content": function ($event) {
                return _vm.$set(_vm.currentComponent, "explainText", $event)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }